import { render, staticRenderFns } from "./restaurantBrandDetails.vue?vue&type=template&id=19b4dbda&scoped=true&lang=en&"
import script from "./restaurantBrandDetails.vue?vue&type=script&lang=js&"
export * from "./restaurantBrandDetails.vue?vue&type=script&lang=js&"
import style0 from "./restaurantBrandDetails.vue?vue&type=style&index=0&id=19b4dbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4dbda",
  null
  
)

export default component.exports